// The unwrapped window.fetch, captured at module-eval time — BEFORE
// installFetchInterceptor() swaps in the 401 → /refresh → retry wrapper.
//
// The auth-dance calls (/csrf-token and /refresh) MUST use this instead of
// the global fetch. If one of them went through the interceptor and returned
// 401 while a refresh was already in flight, the interceptor's 401 handler
// would await the very refresh promise that is itself blocked on that call —
// a deadlock. Routing the auth dance through the raw fetch decouples it from
// the retry machinery.
//
// Ordering: index.js imports the interceptor (which transitively imports
// this module) at the top and only calls installFetchInterceptor() in its
// body. All module evaluation happens before the body runs, so the bind
// below always captures the genuine browser fetch, never the wrapper.
export const rawFetch: typeof window.fetch = window.fetch.bind(window);
